/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferredProjectDeliverableTransactionResource
 */
export interface ReferredProjectDeliverableTransactionResource {
    /**
     * 
     * @type {string}
     * @memberof ReferredProjectDeliverableTransactionResource
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof ReferredProjectDeliverableTransactionResource
     */
    executionDate: Date;
}

/**
 * Check if a given object implements the ReferredProjectDeliverableTransactionResource interface.
 */
export function instanceOfReferredProjectDeliverableTransactionResource(value: object): value is ReferredProjectDeliverableTransactionResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('executionDate' in value) || value['executionDate'] === undefined) return false;
    return true;
}

export function ReferredProjectDeliverableTransactionResourceFromJSON(json: any): ReferredProjectDeliverableTransactionResource {
    return ReferredProjectDeliverableTransactionResourceFromJSONTyped(json, false);
}

export function ReferredProjectDeliverableTransactionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredProjectDeliverableTransactionResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'executionDate': (new Date(json['executionDate'])),
    };
}

export function ReferredProjectDeliverableTransactionResourceToJSON(value?: ReferredProjectDeliverableTransactionResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'executionDate': ((value['executionDate']).toISOString()),
    };
}

